import { extendObservable, observable, action, computed, reaction } from 'mobx';
import uuid from 'node-uuid';
import axios from '../../../libs/axios_csrf';
import ActivityModel from '../models/ActivityModel.js';

export default class ActivityStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
    let activityEdit = new ActivityModel(this, uuid.v4());
    extendObservable(this, {
      activities: [],
      activityEdit: activityEdit,
      isEditing: false,
      loading: false,
      activitiesCount: 0
    });
    this.nextPage = 1;
    this.loading = true;
    this.fetchActivities();
  }

  @action saveEditingActivity() {
    let activity = this.activityEdit;
    // New activity
    if (!this.isEditing) {
      this.activities.push(activity);
      this.createActivityInBackend(activity);
      this.incrementActivitiesCount();
    } else {
      this.updateActivityInBackend(activity);
    }
    this.reinitEditingActivity();
  }

  @action cancelEditingActivity() {
    this.reinitEditingActivity();
    this.isEditing = false;
  }

  @action reinitEditingActivity() {
    this.activityEdit = new ActivityModel(this, uuid.v4());
    this.rootStore.igBusinessStore.resetCardSelection();
  }

  @action loadMoreActivities() {
    this.fetchActivities();
  }

  @action loadActivityAsTemplate(activity) {
    this.isEditing = false;
    this.reinitEditingActivity();
    this.activityEdit.copy(activity);
  }

  @computed get hasMoreItems() {
    return this.nextPage != null;
  }

  getActivityById(id) {
    return this.activities.find(el => el.id == id);
  }

  editActivity(id) {
    const activity = this.getActivityById(id);
    if (activity) {
      this.activityEdit = this.getActivityById(id);
      let cards = activity.getAllSelectedCards();
      for (let card of cards) {
        card.selected = true;
      }
      this.isEditing = true;
    } else {
      this.isEditing = false;
    }
    return this.isEditing;
  }

  createActivityInBackend(activity) {
    axios
      .post('/business_activities.json', {
        business_activity: activity.serialize()
      })
      .then(response => {
        activity.deserialize(response.data);
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  updateActivityInBackend(activity) {
    axios
      .patch('/business_activities/' + activity.id + '.json', {
        business_activity: activity.serialize()
      })
      .then(response => {
        activity.deserialize(response.data);
        console.log(activity);
      })
      .catch(errors => {
        console.log(errors);
      });
  }

  fetchActivities() {
    if (this.nextPage >= 1) {
      axios
        .get('/business_activities.json', {
          params: {
            page: this.nextPage
          }
        })
        .then(response => {
          let activitiesJson = response.data.activities;
          this.activitiesCount = response.data.total_entries;
          this.nextPage = response.data.next_page;
          for (let activityJson of activitiesJson) {
            let activity = new ActivityModel(this, activityJson.id);
            activity.deserialize(activityJson);
            this.activities.push(activity);
          }
          this.loading = false;
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }

  destroyActivity(id) {
    axios
      .delete('/business_activities/' + id + '.json')
      .then(response => {})
      .catch(errors => {
        console.log(errors);
      });
    this.decrementActivitiesCount();
  }

  decrementActivitiesCount() {
    this.activitiesCount -= 1;
  }

  incrementActivitiesCount() {
    this.activitiesCount += 1;
  }
}
